import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import QueueHistory from './QueueHistory.jsx';
import Button from '../common/Button';
import { map } from 'lodash';
import AddUserPopUp from './AddUserPopUp.jsx';
import Gmaps from '../common/Gmaps';
import { appBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class VehiclePersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.editVehicle = this.editVehicle.bind(this);
    this.deleteVehicleInfo = this.deleteVehicleInfo.bind(this);
    this.changedOptions = this.changedOptions.bind(this);
    this.viewLocation = this.viewLocation.bind(this);
    this.state = {
      searchMobile: false,
      notificationVisible: false,
      showSidebar: false,
      valueChanged: '1',
      selectedVehicle: ''
    };
  }

  componentWillMount() {
    //this.props.actions.manageVehicleinfo(this.props.params.id);
    if (this.props.manageuserReducer.vehicleInfo.length == 0) {
      this.props.actions.manageVehicleinfo();
    }
    this.setEditVehicleInfo();
  }

  componentWillReceiveProps(nextprops) {
    if (this.state.selectedVehicle == '') {
      this.setEditVehicleInfo();
    }
  }

  setEditVehicleInfo() {
    if (this.state.selectedVehicle == '') {
      let selectedInfoId = this.props.params.id;
      let allvehicleData = this.props.manageuserReducer.vehicleInfo;
      let selectedDataInfo = '';
      if (allvehicleData.length > 0) {
        map(allvehicleData, (info, index) => {
          if (info.id == selectedInfoId) {
            selectedDataInfo = info;
          }
        });
      }
      this.setState({ selectedVehicle: selectedDataInfo });
      if (selectedDataInfo.id) {
        this.props.actions.JobsQueueHistory(selectedDataInfo.id, 'queue');
        this.props.actions.JobsQueueHistory(selectedDataInfo.id, 'history');
      }
    }
  }

  componentWillUnmount() {}

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  editVehicle(vehicleId) {
    // alert("edit vehicle info ----" +vehicleId)
    this.props.router.push(`${appBasePath}/edit-vehicle/${vehicleId}`);
  }
  deleteVehicleInfo(vehicleId) {
    this.props.actions.deleteVehicle(vehicleId, this.props.router);
  }
  changedOptions(selectedata) {
    this.setState({ valueChanged: selectedata });
    //alert(selectedata);
  }
  viewLocation(lat, long) {
    let InfoLongLat = { latitude: lat, longititude: long };
    this.props.actions.MapsInfo(InfoLongLat);
    this.props.actions.showPopUP();
  }

  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, manageuserReducer } = this.props;
    let phoneNumber = 'tel:' + this.state.selectedVehicle.phone;
    let vehicleStatus = this.state.selectedVehicle ? this.state.selectedVehicle.emergencyvehiclestatus.displayname : '';
    let queueInfo = this.props.manageuserReducer.historyInfo.joblist
      ? this.state.valueChanged == 1
          ? this.props.manageuserReducer.queueInfo && this.props.manageuserReducer.queueInfo.joblist && this.props.manageuserReducer.queueInfo.joblist.data
          : this.props.manageuserReducer.historyInfo && this.props.manageuserReducer.historyInfo.joblist && this.props.manageuserReducer.historyInfo.joblist.data
      : [];
    console.log("queueInfo",queueInfo,this.props.manageuserReducer);
    return (
      <div>
        <AddUserPopUp showpopupType="Maps" manageVehicle={this.props.manageuserReducer} actions={this.props.actions}>
          {' '}
        </AddUserPopUp>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          noAutoSuggestCall="true"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">

          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*message*/}
          {/*<Extra message="Your email account has been verified. We are open for service!" />*/}

          <div className="container-fluid main-container">
            <div className="page-sec-header col">
              <div className="overview-heading headrer-left-pod veh-personal-mob">
                <h5 className="overview-heading-txt">{this.state.selectedVehicle.name}</h5>
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={15}
                  label="Edit"
                  btnCallBack={() => this.editVehicle(this.state.selectedVehicle.id)}
                  customClass="btn-add-user btn-edit-user display-none"
                />
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={15}
                  label="Delete"
                  btnCallBack={() => this.deleteVehicleInfo(this.state.selectedVehicle.id)}
                  customClass="vehicle-truck-button display-none"
                />
                <div className="visible-xs overview-heading-buttons-box veh-personal-buttons-box-mob">
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={15}
                  label="Delete"
                  btnCallBack={() => this.deleteVehicleInfo(this.state.selectedVehicle.id)}
                  customClass="vehicle-truck-button delete-btn"
                />
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={15}
                  label="Edit"
                  btnCallBack={() => this.editVehicle(this.state.selectedVehicle.id)}
                  customClass="btn-add-user btn-edit-user edit-btn"
                />
                </div>
              </div>
              <div className="my-account-body">
                <div className="container-fluid vehicle-list-personal map-wrapper">
                  <div className="row clearfix">
                    <div className="col-xs-3 vehicle-map-personal map-box">
                      <div className="vehicle-map pos-r">
                        <div className="veh-personal-gmaps-opac">
                        </div>
                        <Gmaps
                          center={{
                            lat: Number(this.state.selectedVehicle.latitude),
                            lng: Number(this.state.selectedVehicle.longitude)
                          }}
                          marker={{
                            position: {
                            lat: Number(this.state.selectedVehicle.latitude),
                            lng: Number(this.state.selectedVehicle.longitude)
                            }
                          }}
                          zoom={15}
                          containerElement={<div style={{ height: 'auto', width: 100 + '%' }} />}
                          mapElement={<div style={{ height: 200 + 'px', width: 100 + '%' }} />}
                        />
                      </div>
                    </div>
                    <div className="col-xs-3 vehicle-driver-individual-info individual-info-wrapper">
                      <div className="vehicle-element-individual-info
                                vehicle-element-bold plate-no-txt">
                        {this.state.selectedVehicle.plateNo}
                      </div>
                      <div className="vehicle-element-individual-info vehicle-name vehicle-name-txt">
                        {this.state.selectedVehicle.username}
                      </div>
                      <div className="vehicle-element-individual-info vehicle-link-color vehicle-phone vehicle-phone-box">
                        <label className="mdi mdi-phone" />
                        <a href={phoneNumber}>{this.state.selectedVehicle.phone}</a>
                      </div>
                      <div
                        className="vehicle-element-individual-info vehicle-link-color view-location vehicle-phone view-location-box"
                        onClick={() =>
                          this.viewLocation(this.state.selectedVehicle.latitude, this.state.selectedVehicle.longitude)}
                      >
                        View Location
                      </div>
                    </div>
                    <div className="col-xs-6  vehicle-driver-individual-info individual-info-inner">
                      <div className="vehicle-element-individual-info visible-none display-none">dummy</div>
                      <div className="vehicle-element-individual-info status-txt">Current Status: {vehicleStatus}</div>
                      <div className="vehicle-element-individual-info jobqueue-txt">
                        Job Queue: {this.state.selectedVehicle.jobqueue}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container-fluid navigation-header queue-navigation queue-navigation-box">
                  <div className="row clearfix">
                    <div
                      className={'tabs col-xs-2 navigation-header-tab ' + (this.state.valueChanged === '1' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('1');
                      }}
                    >
                      <span>QUEUE</span>
                    </div>
                    <div
                      className={'tabs col-xs-2 navigation-header-tab ' + (this.state.valueChanged === '2' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('2');
                      }}
                    >
                      <span>HISTORY</span>
                    </div>
                  </div>
                </div>
                <div className="queue-history-box">
                  <QueueHistory selectedoption={this.state.valueChanged} vehicleInfo={queueInfo} />
                </div>

              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyVehicles/VehiclePersonalInfo.jsx